import { render } from "./QuantitySelector.vue?vue&type=template&id=8b170b4e&scoped=true"
import script from "./QuantitySelector.vue?vue&type=script&lang=js"
export * from "./QuantitySelector.vue?vue&type=script&lang=js"

import "./QuantitySelector.vue?vue&type=style&index=0&id=8b170b4e&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b170b4e"]])

export default __exports__